export default __webpack_public_path__ + "static/media/shopsvg.8fc86db9.svg";